"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = newRoutes;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Error = _interopRequireDefault(require("../errors/Error"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * API Main Core Router Component Holder
 * Sam Ayoub <melayyoub@svb.com> (svb.com)
 * Decsriptio: This is only a handler for other components
 * Here where we are checking minimum requirements of routers before running or importing other components
 * How to use? Readme.md
 */

// Mocking Needed
const MainMenu = "../mocking/main-menu.json";
// NewRouters is the new routers for specific landing pages or external
function newRoutes(routes) {
  const [routers, setrouters] = (0, _react.useState)([]);
  //component loaded
  (0, _react.useEffect)(() => {
    routes.length > 0 && routes.map(route => {
      console.log(route.path);
      return setrouters(...routers, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: route.path,
        element: route.component
      }));
    });
  }, [routes]);
  return routers;
}